// Helper function to create DOM element
function createElement(tag, attributes, ...children) {
	const element = document.createElement(tag);
	Object.keys(attributes).forEach(attr => element.setAttribute(attr, attributes[attr]));
	children.forEach(child => {
		if (typeof child === 'string')
			element.appendChild(document.createTextNode(child));
		else
			element.appendChild(child);
	});
	return element;
}

// Map user-provided type to class and icon
function getToastClassAndIcon(type) {
	const mappings = {
		'warning': {class: 'ps-bg-warning', icon: 'fa-exclamation-triangle'},
		'success': {class: 'ps-bg-success', icon: 'fa-check'},
		'danger': {class: 'ps-bg-danger',  icon: 'fa-circle-exclamation'},
		'error': {class: 'ps-bg-danger',  icon: 'fa-circle-exclamation'},
		'primary': {class: 'ps-bg-primary',    icon: 'fa-circle-info'},
		'info': {class: 'ps-bg-primary',    icon: 'fa-circle-info'},
	};

	return mappings[type] || {class: 'ps-bg-default', icon: 'fa-info-circle'};
}

// Standard Toast with close button
async function message(options) {
	return Grape.toast.open('Message', Object.assign({...getToastClassAndIcon(options.type)}, options));
}

export default {
	message
};
